import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {

    auth: {
        clientId: "7709223d-ef5c-4e0b-aa5e-71b955ab4489",
        authority: "https://evarella.b2clogin.com/evarella.onmicrosoft.com/B2C_1_MultiplaSignUpAndInFlow",
        knownAuthorities: "evarella.b2clogin.com,".split(','),
        redirectUri: "http://localhost:3000/evarella",
        postLogoutRedirectUri: "http://localhost:3000/evarella"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {	
                    return;	
                }
                switch (level) {	
                    case LogLevel.Error:	
                        console.error(message);	
                        return;	
                    case LogLevel.Info:	
                        console.info(message);	
                        return;	
                    case LogLevel.Verbose:	
                        console.debug(message);	
                        return;	
                    case LogLevel.Warning:	
                        console.warn(message);	
                        return;	
                }
            }
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
// export const loginRequest = {
//     //scopes: process.env.REACT_APP_ADB2C_LOGIN_SCOPES.split(','),
//     scopes: "".split(','),
// };

// export const editProfile = {
//     authority: process.env.REACT_APP_ADB2C_EDIT_PROFILE_AUTHORITY,
// };

// export const policyNames = {
//     signUpSignIn: "B2C_1_MultiplaSignUpAndInFlow"
// };